import React from "react";
import Card from "carbon-react/lib/components/card";
import CardRow from "carbon-react/lib/components/card/card-row";
import CardColumn from "carbon-react/lib/components/card/card-column";
import CardFooter from "carbon-react/lib/components/card/card-footer";
import Heading from "carbon-react/lib/components/heading";
import Link from "carbon-react/lib/components/link";
import { useAppContext } from "../../../../contexts/AppContext";
import { useLocalization } from "../../../../contexts/localization/Localization";

const MfaEnrollmentCard = ({
  enrollment,
  openDeleteMfaEnrollmentDialog,
  busy,
}) => {
  const { agentEntitlement } = useAppContext();
  const { getLocalizedDateStringFromUtcValue } = useLocalization();

  const isValidFunc = (func) => {
    return func && typeof func === "function";
  };

  const onDeleteMfaEnrollment = () => {
    if (busy) return;

    if (isValidFunc(openDeleteMfaEnrollmentDialog)) {
      openDeleteMfaEnrollmentDialog(enrollment);
    }
  };

  const phoneNumberRow = (
    <>
      {enrollment?.phoneNumber === null ||
      enrollment?.phoneNumber === undefined ? null : (
        <CardRow>
          <CardColumn>
            <strong>Phone number:</strong> {enrollment?.phoneNumber}
          </CardColumn>
        </CardRow>
      )}
    </>
  );

  const createdAtRow = (
    <>
      {enrollment?.createdAtUtc === null ||
      enrollment?.createdAtUtc === undefined ? null : (
        <CardRow>
          <CardColumn>
            <strong>Created at:</strong> {getLocalizedDateStringFromUtcValue(enrollment?.createdAtUtc)}
          </CardColumn>
        </CardRow>
      )}
    </>
  );

  const lastAuthRow = (
    <>
      {enrollment?.lastAuthUtc === null ||
      enrollment?.lastAuthUtc === undefined ? null : (
        <CardRow>
          <CardColumn>
            <strong>Last auth at:</strong> {getLocalizedDateStringFromUtcValue(enrollment?.lastAuthUtc)}
          </CardColumn>
        </CardRow>
      )}
    </>
  );

  const enrolledAtRow = (
    <>
      {enrollment?.enrolledAtUtc === null ||
      enrollment?.enrolledAtUtc === undefined ? null : (
        <CardRow>
          <CardColumn>
            <strong>Enrolled at:</strong> {getLocalizedDateStringFromUtcValue(enrollment?.enrolledAtUtc)}
          </CardColumn>
        </CardRow>
      )}
    </>
  );

  const statusRow = (
    <>
      {enrollment?.status === null ||
      enrollment?.status === undefined ? null : (
        <CardRow>
          <CardColumn>
            <strong>Status:</strong> {enrollment?.status}
          </CardColumn>
        </CardRow>
      )}
    </>
  );


    if (!enrollment) return null;
    let type = "";
    switch (enrollment?.type) {
        case "sms":
            type = "SMS";
            break;
        case "voice":
            type = "Voice Call";
            break;
        case "phone":
            type = "Phone";
            break;
        case "totp":
            type = "Authenticator App (totp)";
            break;
        case "guardian":
            type = "Sage Verify App";
            break;
        case "recovery-code":
            type = "Recovery code";
            break;
        default:
            type = enrollment.type;
            break;
    }

      return (
        <div key={enrollment?.id}>
          <Card key={enrollment?.id}>
            <CardRow>
              <CardColumn>
                <Heading title={type} divider={false} />
              </CardColumn>
            </CardRow>
            <CardRow>
              <CardColumn>
                <strong>ID:</strong> {enrollment?.id}
              </CardColumn>
            </CardRow>
        
            {phoneNumberRow}   
  
            {createdAtRow}

            {enrolledAtRow}

            {lastAuthRow}

            {statusRow}

            <CardFooter>
              {agentEntitlement && agentEntitlement.users.canDeleteMfaEnrollments && (
                <CardColumn align="center" className="hidden">
                  <Link
                    disabled={busy}
                    onClick={() => {
                      onDeleteMfaEnrollment();
                    }}
                    icon="bin"
                    iconAlign="left"
                    tabbable
                  >
                    Delete
                  </Link>
                </CardColumn>
              )}
            </CardFooter>
          </Card>
        </div>
      );
};

export default MfaEnrollmentCard;
